export default {
  props: {
    current: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    percentStyle() {
      const percent = 100 * this.current / this.total;
      return `${percent}%`;
    },
  },
};
